import { SearchAction, SearchActionTypes, SearchState } from './types'

const SEARCH_HISTORY_ENTRIES_LIMIT = 5

export const searchReducer = (
  state: SearchState,
  action: SearchAction
): SearchState => {
  switch (action.type) {
    case SearchActionTypes.SET_SEARCH_HISTORY:
      return {
        ...state,
        searchHistory: [
          action.payload,
          ...state.searchHistory.filter((term) => term !== action.payload),
        ].slice(0, SEARCH_HISTORY_ENTRIES_LIMIT),
      }
    case SearchActionTypes.RECOVER_SEARCH_HISTORY:
      return {
        ...state,
        searchHistory: action.payload,
      }
    case SearchActionTypes.SET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: action.payload,
      }
    case SearchActionTypes.SET_RESULTS:
      return {
        ...state,
        results: state.searchResults,
      }
    case SearchActionTypes.SET_SEARCH_BOX_ACTIVE:
      return {
        ...state,
        searchBoxActive: action.payload,
      }
    case SearchActionTypes.SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
      }
    case SearchActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case SearchActionTypes.SET_MORE_RESULTS:
      return {
        ...state,
        results: [...state.results, ...action.payload],
      }
    case SearchActionTypes.SET_NO_MORE_RESULTS:
      return {
        ...state,
        noMoreResults: action.payload,
      }
    default:
      return state
  }
}
